import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getDrivers } from "../../../actions/admin/driver";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import DriverItem from "./DriverItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Name", width: "tw:w-[220px]" },
  { key: "email", title: "Email", width: "tw:w-[260px]" },
  { key: "phone", title: "Phone Number", width: "tw:w-[180px]" },
  { key: "employment", title: "Full time / Part time", width: "tw:w-[200px]", skeleton: "badge" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "createdOn", title: "Created Date", width: "tw:w-[160px]" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const DriversList = () => {
  const driver = useSelector((state) => state.driver);
  const { loading, drivers } = driver;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDrivers());
  }, [dispatch]);

  return (
    <AdminPage title="Driver List" actions={<AdminCreateButton to="/admin/adddriver" label="Add Driver" />}>
      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1360}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!drivers?.length}
        emptyText="No drivers found."
      >
        {drivers?.map((item, index) => (
          <DriverItem key={item._id} drivers={item} count={index} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default DriversList;
